import { MAX_ITEMS_IN_PAGE } from '../../actions/commonActions';

const initState = {
  holidays: [],
  holiday: {},
  currentPage: 1, 
  totalPages: 0, 
  numItems: 0, 
  min: 1, 
  max: MAX_ITEMS_IN_PAGE,
  holidayFilter: ''
}

const holidaysReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_HOLIDAYS':
      return {
        ...state,
        holidays: action.holidays
      }
    case 'SET_HOLIDAY_FIELD_CHANGE': 
      return {
        ...state, 
        holiday: Object.assign(state.holiday, action.value) 
      }
    case 'SET_HOLIDAY':
      return {
        ...state, 
        holiday: action.holiday 
      }
    case 'RESET_HOLIDAY':
      return {
        ...state,
        holiday: {} 
      }
    case 'HOLIDAY_FILTER':
      return {
        ...state, 
        holidayFilter: action.filter 
      }
    case 'SET_HOLIDAYS_PAGINATION':
      return {
        ...state, 
        numItems: action.numItems, 
        min: action.min, 
        totalPages: action.totalPages,
        currentPage: typeof(action.currentPage) !== "undefined" ? action.currentPage : state.currentPage, 
        max: action.max 
      }
    case 'RESET_HOLIDAYS_PAGINATION':
      return {
        ...state, 
        currentPage: 1, 
        totalPages: 0, 
        numItems: 0, 
        min: 1, 
        max: MAX_ITEMS_IN_PAGE
      }
    default: 
      return state;
  }
}

export default holidaysReducer